/**
 * Canonical user-facing wording for the "estimated/reported" state of an
 * incident's date/time. Used as the field label in the incident form/detail
 * view and in the QAPI / non-QAPI report headers when the incident's
 * Unknown_Date_and_Time__c flag is set. Single source of truth.
 */
export const ESTIMATED_DATE_TIME_LABEL = "Estimated / Reported Date & Time";
